import React, { useState, useRef } from "react";
import NavBar from "../../Components/Navbar/navbar";
import styles from "./calendario.module.css";
import { useEffect } from "react";
import { HiOutlineArrowLeftCircle, HiOutlineArrowRightCircle, HiArrowTopRightOnSquare, HiEye, HiEyeSlash } from "react-icons/hi2";
import axios from "axios";
import { Url, getUser } from "../../Constants/globals";
import RefreshToken from "../../Components/RefreshToken/RefreshToken";
import Switch from "../../Components/Switch/switch";
import Alert from "../../Components/Alert/alert";
import { CirclePicker } from 'react-color'
import { HiPencil, HiTrash, HiBell } from "react-icons/hi";
import DeleteModal from "../../Components/DeleteModal/deletemodal";
import TextareaAutosize from 'react-autosize-textarea';
import { useNavigate } from "react-router-dom";
import Loading from "../../Components/Loading/loading";
import stylesModal from "../../Components/DeleteModal/deletemodal.module.css";

function Modal({id, closeModal, setAlert, setLoading, warningText, fetchData}) {

  const [isPoppedOut, setIsPoppedOut] = useState(false);

  async function notify() {
    await setAlert("");
    await setLoading(<Loading/>);
    try {
      await axios.post(`${Url}/notify-event/${id}`, {}, {
        headers: {
          Authorization: "Bearer " + getUser().token,
        },
      });
      await fetchData();
      await setLoading("");
      await handleClose();
      return setAlert(<Alert type={"success"}>Colaboradores notificados com sucesso</Alert>)
    }
    catch (err) {
      if (err.request && err.request.status === 401){
        var newToken = await RefreshToken(err);
        if (newToken) {
          return await notify();
        } else {
          window.location.reload();
        }
      }
      else {
        console.error(err);
        setLoading("");
        return  setAlert(<Alert type={"error"}>{err?.response?.data?.detail && (typeof err.response.data.detail === "string") ? err.response.data.detail : "Ocorreu um erro ao notificar os colaboradores"}</Alert>);
      }
    };
  }

  function handleClose() {
    setIsPoppedOut(true);
    setTimeout(() => {
      closeModal("");
    }, 250);
  }

  return (
    <div className={`${stylesModal.bodyDelete} ${isPoppedOut ? stylesModal.popout : stylesModal.popin}`}>
      <div className={stylesModal.center}>
        <div className={stylesModal.column}>
          <h4 style={{margin:0}}>Deseja notificar todos os colaboradores?</h4>
          {
            warningText ?
              <p style={{color: "red", fontSize: "11pt", marginTop: "10px"}}>{warningText}</p>
            :""
          }
          <div className={stylesModal.buttons}>
            <button className={stylesModal.actionButton} onClick={() => notify()}>{warningText ? "Notificar novamente" : "Notificar"}</button>
            <button className={stylesModal.backButton} onClick={() => handleClose()}>Regressar</button>
          </div>
        </div>
      </div>
    </div>
  );
}

function getFormattedDate(date) {
  let formattedDate = date;
  if (date.includes("/")){
    const formattedDate2 = date.split("/");
    formattedDate = `${formattedDate2[2]}-${formattedDate2[1]}-${formattedDate2[0]}`
  }
  return formattedDate;
};

async function addEvent(nome, descricao, initialDate, finalDate, every, color, saberMais){
  if (nome === "") return <Alert type={"error"}>O nome é obrigatório</Alert>;
  else if (initialDate === "") return <Alert type={"error"}>A data inicial é obrigatória</Alert>;
  else if (finalDate === "") return <Alert type={"error"}>A data final é obrigatória</Alert>;

  try {
    await axios.post(`${Url}/calendar/create-schedule`, {
      name: nome,
      description: descricao,
      start_date: initialDate,
      end_date: finalDate,
      every_year: every,
      hex: color,
      know_more: saberMais
    }, {
      headers: {
        Authorization: "Bearer "+getUser().token,
      },
    });
    return <Alert type={"success"}>Data adicionada com sucesso!</Alert>;
  }
  catch (err) {
    if (err.request && err.request.status === 401){
      var newToken = await RefreshToken(err);
      if (newToken) return await addEvent(nome, descricao, initialDate, finalDate, every, color, saberMais);
      else window.location.reload();
    }
    else {
      console.error(err?.response?.data?.detail && (typeof err.response.data.detail === "string") ? err.response.data.detail : "Ocorreu um erro ao adicionar a data");
      return <Alert type={"error"}>{err?.response?.data?.detail && (typeof err.response.data.detail === "string") ? err.response.data.detail : "Ocorreu um erro ao adicionar a data"}</Alert>;
    }
  };
}

async function editEvent(id, nome, descricao, initialDate, finalDate, every, color, saberMais){
  if (nome === "") return <Alert type={"error"}>O nome é obrigatório</Alert>;
  else if (initialDate === "") return <Alert type={"error"}>A data inicial é obrigatória</Alert>;
  else if (finalDate === "") return <Alert type={"error"}>A data final é obrigatória</Alert>;
  
  try {
    await axios
    .put(`${Url}/calendar/schedule/${id}`, {
      name: nome,
      description: descricao,
      start_date: initialDate,
      end_date: finalDate,
      every_year: every,
      hex: color,
      know_more: saberMais
    }, {
      headers: {
        Authorization: "Bearer "+getUser().token,
      },
    });
    return <Alert type={"success"}>Data editada com sucesso!</Alert>;
  }
  catch (err) {
    if (err.request && err.request.status === 401){
      var newToken = await RefreshToken(err);
      if (newToken) return await editEvent(id, nome, descricao, initialDate, finalDate, every, color, saberMais);
      else window.location.reload();
    }
    else {
      console.error(err?.response?.data?.detail && (typeof err.response.data.detail === "string") ? err.response.data.detail : "Ocorreu um erro ao editar a data");
      return <Alert type={"error"}>{err?.response?.data?.detail && (typeof err.response.data.detail === "string") ? err.response.data.detail : "Ocorreu um erro ao editar a data"}</Alert>;
    }
  };
}

async function deleteEvent(id){
  try {
    await axios.delete(`${Url}/calendar/schedule/${id}`, {
      headers: {
        Authorization: "Bearer " + getUser().token,
      },
    });
    return [200, <Alert type={"success"}>Data eliminada com sucesso!</Alert>];
  }
  catch (err) {
    if (err.request && err.request.status === 401){
      var newToken = await RefreshToken(err);
      if (newToken) return await deleteEvent(id);
      else window.location.reload();
    }
    else {
      console.error(err);
      return  [0, <Alert type={"error"}>{err?.response?.data?.detail && (typeof err.response.data.detail === "string") ? err.response.data.detail : "Ocorreu um erro ao eliminar a data"}</Alert>];
    }
  };
}

async function getAllEvents(){
  try {
    const res = await axios.get(`${Url}/next-events?per_page=30000000`, {
      headers: {
        Authorization: "Bearer "+getUser().token,
      },
    });
    return res.data.data;
  }
  catch (err) {
    if (err.request && err.request.status === 401){
      var newToken = await RefreshToken(err);
      if (newToken) return await getAllEvents();
      else window.location.reload();
    }
    else {
      console.error(err);
      return [];
    }
  };
}

async function getCalendar(month, year){
  try {
    const res = await axios.get(`${Url}/calendar${month ? "?month="+ month : ""}${year ? "&year="+ year : ""}`, {
      headers: {
        Authorization: "Bearer "+getUser().token,
      },
    });
    return res.data;
  }
  catch (err) {
    if (err.request && err.request.status === 401){
      var newToken = await RefreshToken(err);
      if (newToken) return await getCalendar(month, year);
      else window.location.reload();
    }
    else {
      console.error(err);
      return [];
    }
  };
}

function Calendario({userPermissions}) {

  const divRef = useRef(null);
  const navigate = useNavigate();
  const [loading, setLoading] = useState("");
  const [modalNotif, setModalNotif] = useState("");
  const [loadingData, setLoadingData] = useState(true);
  const [allEvents, setAllEvents] = useState([]);
  const [daysOfWeek, setDaysOfWeek] = useState([]);
  const [currentMonthName, setCurrentMonthName] = useState("");
  const [currentYear, setCurrentYear] = useState("");
  const [nextMonth, setNextMonth] = useState("");
  const [nextMonthYear, setNextMonthYear] = useState("");
  const [previousMonth, setPreviousMonth] = useState("");
  const [previousMonthYear, setPreviousMonthYear] = useState("");
  const [selectedDay, setSelectedDay] = useState("");
  const [nome, setNome] = useState("");
  const [descricao, setDescricao] = useState("");
  const [linkSaberMais, setLinkSaberMais] = useState("");
  const [initialDate, setInitialDate] = useState("");
  const [finalDate, setFinalDate] = useState("");
  const [everyyear, setEveryyear] = useState(false);
  const [alert, setAlert] = useState("");
  const [selectedEvent, setSelectedEvent] = useState("");
  const [eventColor, setEventColor] = useState("#ff3838");
  const [todaysDate, setTodaysDate] = useState('');
  const [deleteEventModal, setDeleteEventModal] = useState("");
  const [seeEvents, setSeeEvents] = useState(true);

  useEffect(() => {
    const today = new Date();
    const year = today.getFullYear();
    const month = String(today.getMonth() + 1).padStart(2, '0');
    const day = String(today.getDate()).padStart(2, '0');
    const formattedDate = `${year}-${month}-${day}`;
    setTodaysDate(formattedDate);
    assignCalendar();
  }, []);

  async function assignCalendar(month, year) {
    const allNextEvents = await getAllEvents();
    setAllEvents(allNextEvents);
    const thisCalendarData = await getCalendar(month, year);
    setCurrentMonthName(thisCalendarData.current_month_name);
    setCurrentYear(thisCalendarData.current_year);
    setNextMonth(thisCalendarData.next_month);
    setNextMonthYear(thisCalendarData.next_month_year);
    setPreviousMonth(thisCalendarData.last_month);
    setPreviousMonthYear(thisCalendarData.last_month_year);
    getDays(thisCalendarData.last_day_of_the_month, thisCalendarData.first_week_day, thisCalendarData.current_year, thisCalendarData.current_month, thisCalendarData.current_day, thisCalendarData.schedules);
  }

  function handleSelectDay(currentYear, currentMonth, currentDay, day) {
    setSelectedEvent("");
    setNome("");
    setDescricao("");
    setLinkSaberMais("");
    setEveryyear(false);
    if (day < 10) day = `0${day}`;
    if(currentDay <= day) {
      setInitialDate(`${currentYear}-${currentMonth}-${day}`);
      setFinalDate(`${currentYear}-${currentMonth}-${day}`);
      setSelectedDay(day);
      setTimeout(() => {
        divRef.current.scrollTo({
          top: divRef.current.scrollHeight,
          behavior: 'smooth'
        });
      }, 150);
    }
    else setSelectedDay("");
  }

  function handleInitialDate(e){
    if (e.target.value > finalDate) setFinalDate(e.target.value);
    setInitialDate(e.target.value);
  }

  function handleFinalDate(e){
    setFinalDate(e.target.value);
  }

  function handleDelete(event, schedule){
    event.stopPropagation();
    setDeleteEventModal(<DeleteModal close={setDeleteEventModal} objectId={schedule.id} objectName={schedule.name} deleteFunction={getAlertDeleteEvent}/>)
  }

  function handleEditEvent(event, schedule){
    event.stopPropagation();
    setNome(schedule.name);
    setDescricao(schedule.description ?? "");
    setLinkSaberMais(schedule.know_more ?? "");
    setEventColor(schedule.hex);
    setInitialDate(getFormattedDate(schedule.start_date));
    setFinalDate(getFormattedDate(schedule.end_date));
    setEveryyear(schedule.every_year ?? false);
    setSelectedDay("");
    setSelectedEvent(schedule);
    setTimeout(() => {
      divRef.current.scrollTo({
        top: divRef.current.scrollHeight,
        behavior: 'smooth'
      });
    }, 150);
  }

  const getDays = async (lastDayOfTheMonth, firstDayOfTheWeek, currentYear, currentMonth, currentDay, eventDays) => {
    let days = [];
    for (let a = 0; a < lastDayOfTheMonth; a++){
      days.push(
        <div key={a} className={styles.dayBox} style={{gridColumnStart: a === 0 ? firstDayOfTheWeek === 0 ? 7 : firstDayOfTheWeek : "", backgroundColor: currentDay > a+1 ? "#ff0a0a10" : ""}} onClick={() => {handleSelectDay(currentYear, currentMonth, currentDay, a+1)}}>
          <p style={{userSelect: "none", fontWeight: a+1 === currentDay ? "900" : ""}}>{a+1}</p>
          {
            eventDays.map((event) =>
              event?.day === a+1 ?
                event?.schedules.map((schedule, index) =>
                  <div key={schedule.id} className={styles.event} style={index === event.schedules.length - 1 ? {borderBottomLeftRadius: "6px", borderBottomRightRadius: "6px", backgroundColor: schedule.hex} : {marginBottom: "3px", backgroundColor: schedule.hex}} onClick={(e) => handleEditEvent(e, schedule)}>
                    <p className={styles.eventParagraph} style={{fontSize: "9pt"}} title={schedule.name}>{schedule.name}</p>
                  </div>
                )
              :""
            )
          }
        </div>
      )
    }
    setDaysOfWeek(days);
    setLoadingData(false);
  }

  function changeMonth(month, year) {
    assignCalendar(month, year);
  }

  function handleColorChange(color){
    setEventColor(color.hex);
  }

  async function getAlertAddEvent() {
    await setAlert("");
    const res = await addEvent(nome, descricao, initialDate, finalDate, everyyear, eventColor, linkSaberMais);
    setAlert(res);
    assignCalendar();
  }

  async function getAlertEditEvent() {
    await setAlert("");
    const res = await editEvent(selectedEvent.id, nome, descricao, initialDate, finalDate, everyyear, eventColor, linkSaberMais);
    setAlert(res);
    assignCalendar();
  }

  async function getAlertDeleteEvent(id) {
    if (id){
      await setAlert("");
      const res = await deleteEvent(id);
      setAlert(res[1]);
      setSelectedEvent("");
      assignCalendar();
      return res;
    }
  }

  return (
    <div className="body" ref={divRef}>
      {loading}
      {modalNotif}
      {alert}
      {deleteEventModal}
      <NavBar current={"calendario"} setDisappear={setLoadingData} userPermissions={userPermissions} />
      {
        loadingData ? ""
        :
        <div className={styles.content}>
          {
            allEvents.length > 0 ?
            <div>
              <h1 className={styles.backgroundName}>Datas agendadas 
                {
                  seeEvents ? <HiEyeSlash className={styles.eye} onClick={() => setSeeEvents(!seeEvents)} />
                  :
                  <HiEye className={styles.eye} onClick={() => setSeeEvents(!seeEvents)} />
                }
              </h1>
              {
                seeEvents ?
                  <div className={styles.events}>
                    {
                      allEvents.map((event) =>
                        <div key={event.id} className={styles.evento}>
                          <div title={event.campaign_id ? "Campanha" : ""} className={styles.nextEvent}>
                            <div className={styles.circle} style={{backgroundColor: event.hex}} />
                            <p>{event.name}</p>
                            <div style={{display: "flex", alignItems: "center"}}>
                              <HiPencil className={styles.icon} onClick={(e) => handleEditEvent(e, event)} />
                              <HiTrash className={styles.icon} onClick={(e) => handleDelete(e, event)}/>
                              {
                                event.campaign_id ? ""
                                :
                                <HiBell className={styles.icon} style={event.notified ? {opacity: 0.4} : {}} onClick={() => setModalNotif(<Modal closeModal={setModalNotif} fetchData={assignCalendar} id={event.id} setAlert={setAlert} setLoading={setLoading} warningText={event.notified ? `Este acontecimento já foi notificado a ${event.notified}` : ""} />) }/>
                              }
                            </div>
                          </div>
                        </div>
                      )
                    }  
                  </div>
                :""
              }
            </div>
            :""
          }

          <div className={styles.monthArrows}>
            {
              previousMonth && previousMonthYear ?
              <HiOutlineArrowLeftCircle size={26} style={{cursor: "pointer"}} onClick={() => changeMonth(previousMonth, previousMonthYear)}/>
              :
              <HiOutlineArrowLeftCircle size={26} style={{color: "transparent"}}/>
            }
            <p style={{userSelect: "none", minWidth: "160px", textAlign: "center"}}>{currentMonthName} {currentYear}</p>
            {
              nextMonth && nextMonthYear ?
              <HiOutlineArrowRightCircle size={26} style={{cursor: "pointer"}} onClick={() => changeMonth(nextMonth, nextMonthYear)}/>
              :
              <HiOutlineArrowLeftCircle size={26} style={{color: "transparent"}}/>
            }
          </div>
          <div className={styles.calendario}>
            <div className={styles.weekdays}>
              <p>S</p>
              <p>T</p>
              <p>Q</p>
              <p>Q</p>
              <p>S</p>
              <p>S</p>
              <p>D</p>
            </div>
            <div className={styles.days}>
              {daysOfWeek}
            </div>
          </div>
          {
            selectedDay ?
            <div className={styles.adicionarEvento}>
              <h3>Adicionar data</h3>
              <div className={styles.formBlock}>
                <div className={styles.formBlockSection}>
                  <p>Nome:</p>
                  <input
                    value={nome}
                    onChange={(e) => setNome(e.target.value)}
                  />
                </div>
                <div className={styles.formBlockSection}>
                  <p>Descrição:</p>
                  <TextareaAutosize
                    style={{resize: "none"}}
                    value={descricao}
                    onChange={(e) => setDescricao(e.target.value)}
                  />
                </div>
                <div className={styles.formBlockSection}>
                  <p>Link (saber mais):</p>
                  <input
                    value={linkSaberMais}
                    onChange={(e) => setLinkSaberMais(e.target.value)}
                  />
                </div>
                <div className={styles.formBlockSection}>
                  <p>Data inicial:</p>
                  <input
                    type="date"
                    value={initialDate}
                    min={todaysDate}
                    onChange={(e) => handleInitialDate(e)}
                  />
                </div>
                <div className={styles.formBlockSection}>
                  <p>Data final:</p>
                  <input
                    type="date"
                    value={finalDate}
                    min={initialDate}
                    onChange={(e) => handleFinalDate(e)}
                  />
                </div>
                <div style={{display: "flex", alignItems: "center", gap: "1rem", backgroundColor: "var(--inputBackground)", width: "fit-content", padding: "0 1rem"}}>
                  <p style={{fontSize: "11pt"}}>Marcar anualmente?</p>
                  <Switch value={everyyear} setValue={setEveryyear}/>
                </div>
                <div style={{display: "flex", justifyContent: "space-between", alignItems: "center", backgroundColor: "var(--inputBackground)", padding: "1rem", borderRadius: "4px"}}>
                  <CirclePicker
                    colors={["#ff3838", "#ff1a66", "#d524f5", "#ff80df", "#6105ff", "#2196f3", "#8bd9fe", "#00bcd4", "#009688", "#4caf50", "#8bc34a", "#cddc39", "#ffeb3b", "#ffc107", "#ff9800", "#ff5722", "#8954c7", "#99aeb8"]}
                    color={eventColor}
                    onChange={(color) => handleColorChange(color)}
                  />
                  <div className={styles.exampleEvent}>
                    <p>{new Date(initialDate).getDate()}</p>
                    <div className={styles.eventExample} style={{backgroundColor: eventColor}}>
                      <p>{nome}</p>
                    </div>
                  </div>
                </div>
                <button className={styles.btn} type="" onClick={() => getAlertAddEvent()}>Confirmar</button>
              </div>
            </div>
            :""
          }
          {
            selectedEvent ?
            <div className={styles.adicionarEvento}>
              <h3>Editar data</h3>
              <div className={styles.formBlock}>
                <div className={styles.formBlockSection}>
                  <p>Nome:</p>
                  <input
                    value={nome}
                    onChange={(e) => setNome(e.target.value)}
                  />
                </div>
                <div className={styles.formBlockSection}>
                  <p>Descrição:</p>
                  <TextareaAutosize
                    style={{resize: "none"}}
                    value={descricao}
                    onChange={(e) => setDescricao(e.target.value)}
                  />
                </div>
                <div className={styles.formBlockSection}>
                  <p>Link (saber mais):</p>
                  <input
                    value={linkSaberMais}
                    onChange={(e) => setLinkSaberMais(e.target.value)}
                  />
                </div>
                <div className={styles.formBlockSection}>
                    <p>Data inicial:</p>
                    <input
                      type="date"
                      value={initialDate}
                      min={todaysDate}
                      onChange={(e) => handleInitialDate(e)}
                    />
                </div>
                <div className={styles.formBlockSection}>
                    <p>Data final:</p>
                    <input
                      type="date"
                      min={initialDate}
                      value={finalDate}
                      onChange={(e) => handleFinalDate(e)}
                    />
                </div>
                <div style={{display: "flex", alignItems: "center", gap: "1rem", backgroundColor: "var(--inputBackground)", width: "fit-content", padding: "0 1rem", borderRadius: "4px"}}>
                  <p style={{fontSize: "11pt"}}>Marcar anualmente?</p>
                  <Switch value={everyyear} setValue={setEveryyear}/>
                </div>
                {
                  selectedEvent.campaign_id ?
                    <div onClick={() => navigate(`/campanhas/${selectedEvent.campaign_id}`)} style={{display: "flex", alignItems: "center", gap: "1rem", backgroundColor: "var(--inputBackground)", width: "fit-content", padding: "0 1rem", borderRadius: "4px"}}>
                      <p style={{fontSize: "11pt"}}>Ir para campanha</p>
                      <HiArrowTopRightOnSquare />
                    </div>
                  :""
                }
                <div className={styles.colorAndExample}>
                  <CirclePicker
                    colors={["#ff3838", "#ff1a66", "#d524f5", "#ff80df", "#6105ff", "#2196f3", "#8bd9fe", "#00bcd4", "#009688", "#4caf50", "#8bc34a", "#cddc39", "#ffeb3b", "#ffc107", "#ff9800", "#ff5722", "#8954c7", "#99aeb8"]}
                    color={eventColor}
                    onChange={(color) => handleColorChange(color)}/>
                  <div className={styles.exampleEvent}>
                    <p>{new Date(initialDate).getDate()}</p>
                    <div className={styles.eventExample} style={{backgroundColor: eventColor}}>
                      <p>{nome}</p>
                    </div>
                  </div>
                </div>
                <button className={styles.btn} type="" onClick={() => getAlertEditEvent()}>Confirmar</button>
              </div>
            </div>
            :""
          }
        </div>
      }
    </div>
  );
}

export default Calendario;